import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Fade } from '@mui/material';
import { FADE_TIMEOUT } from './constants';

function PageLoader({ className }) {
  const [isIn, setIsIn] = useState(true);

  useEffect(() => {
    const fadeInterval = setInterval(() => setIsIn((prev) => !prev), FADE_TIMEOUT);
    return () => clearInterval(fadeInterval);
  }, []);

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }} className={className}>
      <CircularProgress
        variant="determinate"
        value={100}
        size="9rem"
        thickness={1.5}
        className="loaderCircle"
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Fade in={isIn} timeout={FADE_TIMEOUT}>
          <img src="/img/oduCrown_blue.svg" height={64} width={64} alt="ODU Logo" />
        </Fade>
      </Box>
    </Box>
  );
}

export default PageLoader;
